<template>
  <div class="weather-card" :class="isActive?'is-active':''" :style="cardStyle">
    <!--气象卡片-->
    <div class="weather-icon" :style="iconWrapStyle"><i v-if="iconClass" :style="iconStyle" class="cjmWeatherIconFont"
                                                        :class="iconClass"></i></div>
    <div class="weather-value" :style="valueStyle">{{ value }}</div>
    <div class="weather-title" :style="titleStyle">{{ title }}</div>
  </div>
</template>
<script>
  import resize from '../../mixins/resize';

  const titleMap = {
    1: '环境温度', 2: '环境湿度', //3: '风向',
    4: '风力风向',
    5: '降水量', 6: '光照强度', 7: '土壤温度', 8: '土壤水分',
    9: '环境气压', 10: 'PH值', 11: '土壤盐分', 12: '蒸发量', 13: '二氧化碳',
    14: '光照辐射', 15: '氨气', 16: '硫化氢', 17: 'PM10', 18: '日照时数', 19: '光合辐射',
    20: '海拔高度',
    36: '土壤温度',// 37: '土壤温度2', 38: '土壤温度3', 39: '土壤温度4',
    40: '土壤湿度',// 41: '土壤湿度2', 42: '土壤湿度3', 43: '土壤湿度4',
    101: '空气温度', //墨迹
    102: '空气气压', //墨迹
    //103: '风向', //墨迹
    104: '风力风向', //墨迹
    105: '日出', //墨迹
    106: '日落', //墨迹
    107: '相对湿度', //墨迹
    108: '紫外线强度' //墨迹
  };
  const zaTitleMap = { //左岸
    1: '风力风向', 2: '风力风向', 3: '降水量',
    4: '空气温度', 5: '相对湿度', 6: '环境气压',
    7: '光照强度', 8: 'PM2.5', 9: '土壤温度', 10: '土壤湿度',
    11: '土壤电导率', 12: '土壤镉离子'
  };
  const iconMap = {
    1: 'cjm-weather-icon-duoyun',
    2: 'cjm-weather-icon-xiangduishidu', //环境湿度
    3: 'cjm-weather-icon-fenglifengxiang',
    4: 'cjm-weather-icon-fenglifengxiang',
    5: 'cjm-weather-icon-jiangshuiliang',
    6: 'cjm-weather-icon-guangzhaoqiangdu',
    7: 'cjm-weather-icon-turangwendu',
    8: 'cjm-weather-icon-turangshidu',
    9: 'cjm-weather-icon-kongqiqiya',
    10: 'cjm-weather-icon-turangPHzhi',
    11: 'cjm-weather-icon-turangyanfen',
    12: 'cjm-weather-icon-zhengfaliang',
    13: 'cjm-weather-icon-eryanghuatan',
    14: 'cjm-weather-icon-guangzhaoqiangdu',
    15: 'cjm-weather-icon-anqi',
    16: 'cjm-weather-icon-liuhuaqing1',
    17: 'cjm-weather-icon-PM',
    18: 'cjm-weather-icon-shinetimes',
    19: 'cjm-weather-icon-shinerange',
    20: 'cjm-weather-icon-altitude', //
    36: 'cjm-weather-icon-turangwendu',
    37: 'cjm-weather-icon-turangwendu',
    38: 'cjm-weather-icon-turangwendu',
    39: 'cjm-weather-icon-turangwendu',
    40: 'cjm-weather-icon-turangshidu',
    41: 'cjm-weather-icon-turangshidu',
    42: 'cjm-weather-icon-turangshidu',
    43: 'cjm-weather-icon-turangshidu',
    101: 'cjm-weather-icon-duoyun', //墨迹
    102: 'cjm-weather-icon-kongqiqiya', //墨迹
    103: 'cjm-weather-icon-fenglifengxiang', //墨迹
    104: 'cjm-weather-icon-fenglifengxiang', //墨迹
    105: 'cjm-weather-icon-richurila', //墨迹
    106: 'cjm-weather-icon-richurila', //墨迹
    107: 'cjm-weather-icon-turangwendu', //墨迹
    108: 'cjm-weather-icon-guangzhaoqiangdu' //墨迹 紫外线强度
  };
  const zaIconMap = {
    1: 'cjm-weather-icon-fenglifengxiang', 2: 'cjm-weather-icon-fenglifengxiang',
    3: 'cjm-weather-icon-jiangshuiliang', 4: 'cjm-weather-icon-duoyun',
    5: 'cjm-weather-icon-xiangduishidu', 6: 'cjm-weather-icon-kongqiqiya',
    7: 'cjm-weather-icon-guangzhaoqiangdu', 8: 'cjm-weather-icon-PM',
    9: 'cjm-weather-icon-turangwendu', 10: 'cjm-weather-icon-turangshidu',
    11: 'cjm-weather-icon-soil-conductivity', 12: 'cjm-weather-icon-soil-spacer'
  };
  export default {
    props: ['isActive', 'bgColor', 'cardData', 'deviceType'],
    mixins: [resize()],
    data() {
      return {
        cardWidth: 0,
        cardHeight: 0
      };
    },
    computed: {
      iconStyle() {
        const min = this.cardHeight > this.cardWidth ? this.cardWidth : this.cardHeight;
        const fontSize = parseInt(min * 0.35) + 'px';
        const style = {fontSize};
        return style;
      },
      iconWrapStyle() {
        const min = this.cardHeight > this.cardWidth ? this.cardWidth : this.cardHeight;
        const paddingBottom = parseInt(min * 0.35) + 'px';
        let valFz = parseInt(this.cardWidth * 0.1);
        valFz = valFz < 12 ? 12 : valFz;
        let titleFz = parseInt(this.cardWidth * 0.082);
        titleFz = titleFz < 12 ? 12 : titleFz;
        const marginTop = ((this.cardHeight - 10 - parseInt(min * 0.35) - valFz - parseInt(valFz * 0.25) - titleFz - parseInt(titleFz * 0.25)) / 2) + 'px';
        const style = {marginTop, paddingBottom};
        return style;
      },
      cardStyle() {
        const {bgColor} = this;
        const style = {backgroundColor: bgColor, border: '2px solid ' + bgColor};
        if (this.isActive) {
          style.border = '2px solid #fff';
        }
        return style;
      },
      valueStyle() {
        const fz = parseInt(this.cardWidth * 0.1);
        const mt = parseInt(fz * 0.25);
        const style = {fontSize: fz + 'px', marginTop: mt + 'px'};
        return style
      },
      titleStyle() {
        const fz = parseInt(this.cardWidth * 0.082);
        const mt = parseInt(fz * 0.25);
        const style = {fontSize: fz + 'px', marginTop: mt + 'px'};
        return style
      },
      key() {
        return this.cardData.key;
      },
      iconClass() {
        if (this.deviceType == 2) { //左岸
          return zaIconMap[this.key];
        }
        return iconMap[this.key]
      },
      value() {
        return this.cardData.value
      },
      title() {
        if (this.deviceType == 2) { //左岸
          return zaTitleMap[this.key];
        }
        return titleMap[this.key]
      }
    },
    methods: {
      onResize() {
        this.cardWidth = this.$el.offsetWidth;
        this.cardHeight = this.$el.offsetHeight;
      }
    }
  }
</script>
<style rel="stylesheet/less" lang="less" scoped>
  @import (less)"../../assets/aio-weather/iconfont.css";

  .weather-card {
    box-sizing: border-box;
    text-align: center;
    font-size: 0;
  }

  .weather-icon {
    position: relative;
    display: inline-block;
    width: 35%;
    padding-bottom: 35%;
    border-radius: 50%;
    i {
      position: absolute;
      font-size: 15px;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      color: #fff;
    }
  }

  .weather-value {
    display: block;
    font-size: 20px;
    color: #ffffff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 85%;
    margin: 0 auto;
  }

  .weather-title {
    display: block;
    font-size: 16px;
    color: #ffffff;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// weather-card.vue?31696058